import React from "react";
import { Col } from "react-bootstrap";
import AnniversaryUser from "./AnniversaryUser";
import "./AnniversaryMonth.css";

function AnniversaryMonth({ title, title_english, users, count, language }) {
  return (
    <Col className="anniversary-month">
      <Col className="anniversary-month-header">
        <h3>{language === "es" ? title : title_english}</h3>
      </Col>
      <Col className="anniversary-month-content">
        {users.map((user) => (
          <AnniversaryUser
            key={user._id}
            firstName={user.firstName}
            lastName={user.lastName}
            profileName={user.profileName}
            profileNameEnglish={user.profileNameEnglish}
            language={language}
            day={user.day}
            years={user.years}
          />
        ))}
      </Col>
    </Col>
  );
}

export default AnniversaryMonth;
